import { ResponseData } from '@playbooks/action-cards-utils/src/types'
import { RadioGroupItem } from '@playbooks/ui/components/radio-group'
import { cn } from '@playbooks/ui/lib/utils'
import MarkdownText from '../../../components/MarkdownText'
import { DynamicFaIcon } from '../../../components/DynamicFaIcon'
import { CheckIcon } from '../../../components/ui'
import { Checkbox } from '@playbooks/ui/components/checkbox'

export default function Response({
  response,
  isRadioButton = false,
  iconClass,
  isFunnelView = false,
}: {
  response: ResponseData
  iconClass: string | undefined
  isRadioButton?: boolean
  isFunnelView?: boolean
}) {
  const id = `${isRadioButton ? 'single' : 'multi'}-select-${response.id}`
  const checked = isFunnelView || !!response.checked

  return (
    <div
      key={id}
      id={`label${response.id}`}
      data-response-id={response.id}
      data-radio={isRadioButton}
      data-checked={!!response.checked}
      className={cn(
        'group/response',
        'AC_response',
        'text-foreground h-full',
        'border-input hover:bg-muted/50 font-normal leading-5 gap-0 cursor-pointer',
        'relative flex items-center rounded-lg border px-3 min-h-9 transition-colors w-full response-frame',

        'gap-3',
        'group-data-[view=default]/app:gap-3',
        'data-[radio=true]:group-data-[view=funnel]/app:gap-0',
        'group-data-[view=default]/app:data-[checked=true]:bg-muted',

        'group-data-[view=doc]/app:border-transparent',
        'group-data-[view=doc]/app:min-h-0',
        'group-data-[view=doc]/app:gap-2',

        'data-[radio=true]:group-data-[view=funnel]/app:py-6',
        'data-[radio=true]:group-data-[view=funnel]/app:text-center',

        'group-data-[view=funnel]/app:py-1',
        'group-data-[view=funnel]/app:pyx-3',
        'group-data-[view=funnel]/app:min-h-16.5',

        'group-data-[view=funnel]/app:data-[checked=true]:bg-input/50',
        'dark:group-data-[view=funnel]/app:data-[checked=true]:bg-[#333333]',

        cn(isRadioButton && 'group-data-[view=funnel]/app:flex-col', 'group-data-[view=funnel]/app:rounded-md'),
      )}
    >
      {isFunnelView && isRadioButton && (
        <div
          className="
          flex justify-center items-center 
          size-8 bg-input group-data-[checked=true]/response:bg-(--color-ac-accent) rounded-full mb-3 text-base text-white
        "
        >
          <DynamicFaIcon iconName={iconClass} fallback={<CheckIcon />} />
        </div>
      )}

      {isRadioButton ? (
        !isFunnelView ? (
          <RadioGroupItem
            checked={!!response.checked}
            value={response.id.toString()}
            className="bg-background group-data-[view=funnel]/app:hidden"
          />
        ) : null
      ) : (
        <Checkbox
          className={cn(
            'pointer-events-none',
            'group-data-[view=funnel]/app:size-8',
            'group-data-[view=funnel]/app:rounded-full',
            'group-data-[view=funnel]/app:bg-border!',
            'group-data-[view=funnel]/app:border-border!',

            'dark:group-data-[view=funnel]/app:bg-primary-foreground!',
            'dark:group-data-[view=funnel]/app:bg-primary-foreground!',
            'dark:group-data-[view=funnel]/app:border-primary-foreground!',
            // 'dark:group-data-[view=funnel]/app:text-white!',
            'dark:text-black',

            'group-data-[view=funnel]/app:group-data-[checked=true]/response:bg-(--color-ac-accent)!',
            'group-data-[view=funnel]/app:group-data-[checked=true]/response:border-(--color-ac-accent)!',

            'dark:group-data-[view=funnel]/app:group-data-[checked=true]/response:bg-(--color-ac-accent)!',
            'dark:group-data-[view=funnel]/app:group-data-[checked=true]/response:border-(--color-ac-accent)!',
            'dark:group-data-[checked=true]/response:text-white!',

            'dark:group-data-[view=funnel]/app:group-data-[checked=false]/response:group-hover/response:bg-input!',
          )}
          checked={checked}
        />
      )}

      <span className="text-sm">
        <MarkdownText text={response.answer} custom />
      </span>
    </div>
  )
}
